// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Details-module__container___nwx71 {
    width: 100%;
    background-color: white;
    border: 1px solid var(--bmo-primary-color-lavender);
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);
    transform-style: preserve-3d;
    transition: transform 0.3s ease;
}

.Details-module__table___m6bYL {
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
    table-layout: fixed;
}

    .Details-module__table___m6bYL td {
        padding: 8px;
        text-align: left;
        vertical-align: middle;
        font-size: 14px;
        line-height: 1.4;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .Details-module__table___m6bYL tr:hover {
        background-color: rgba(0, 0, 0, 0.02);
    }

.Details-module__boldText___c1qjA {
    font-weight: 600;
    color: #333;
    padding-right: 16px;
}
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/SummaryPage/Details/Details.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,uBAAuB;IACvB,mDAAmD;IACnD,aAAa;IACb,kBAAkB;IAClB,sGAAsG;IACtG,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;AACvB;;IAEI;QACI,YAAY;QACZ,gBAAgB;QAChB,sBAAsB;QACtB,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,qCAAqC;IACzC;;AAEJ;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB","sourcesContent":[".container {\n    width: 100%;\n    background-color: white;\n    border: 1px solid var(--bmo-primary-color-lavender);\n    padding: 16px;\n    border-radius: 8px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);\n    transform-style: preserve-3d;\n    transition: transform 0.3s ease;\n}\n\n.table {\n    width: 100%;\n    border-spacing: 0;\n    border-collapse: collapse;\n    table-layout: fixed;\n}\n\n    .table td {\n        padding: 8px;\n        text-align: left;\n        vertical-align: middle;\n        font-size: 14px;\n        line-height: 1.4;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    .table tr:hover {\n        background-color: rgba(0, 0, 0, 0.02);\n    }\n\n.boldText {\n    font-weight: 600;\n    color: #333;\n    padding-right: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Details-module__container___nwx71`,
	"table": `Details-module__table___m6bYL`,
	"boldText": `Details-module__boldText___c1qjA`
};
export default ___CSS_LOADER_EXPORT___;
